module.exports = __webpack_public_path__ + "static/media/Life.337933db.svg";